
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import ManifestModule from "@/store/modules/barcodeSystem/manifest";
import { ManifestDetailListItem } from "@/models/api/barcodeSystem/manifests/get";
import { formatDateWithTime } from "@/utils";
import AvailableOrderTable from "@/components/barcodeSystem/manifest/AvailableOrderTable.vue"
import notifications from "@/lib/notifications";

const manifestModuleState = getModule(ManifestModule);

@Component({
  components: {
    AvailableOrderTable
  }
})
export default class ManifestDetailTable extends Vue {
  @Prop({ default: false })
  loading: boolean;
  showAddOrderModal: boolean = false;
  addOrdersLoading: boolean = false;

  get manifestDetails(): Array<ManifestDetailListItem> {
    return manifestModuleState.currentManifestDetails;
  }

  get selectedItemCount(): number {
    return manifestModuleState.getSelectedManifestDetailCount;
  }

  get selectedItems(): Array<any> {
    return manifestModuleState.getSelectedManifestDetails;
  }

  get totalItems() {
    if (manifestModuleState.currentManifestDetails) {
      return manifestModuleState.currentManifestDetails.length
    } else {
      return 0;
    }
  }

  getComponentData(rowData) {
    return {
      on: {
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }

  formatDateWithTime(val)
  {
    return formatDateWithTime(val)
  }

  onDoubleClicked(data) {
    
  }

  onRowClick(data) { 
    this.unselectAll();
    manifestModuleState.switchManifestDetailSelectionStatus(data.orderId);
  }

  unselectAll() {
    let items = this.selectedItems;

    items.forEach(item => {
      manifestModuleState.switchManifestDetailSelectionStatus(item.orderId);
    });
  }
  async addOrder() {
    this.showAddOrderModal = true;
    if(!manifestModuleState.availableOrders || manifestModuleState.availableOrders.length == 0)
    {
      this.refreshAvailableOrders();
    }
  }

  async refreshAvailableOrders(){   
    this.addOrdersLoading = true;
    try {
      await manifestModuleState.loadAvailableOrders(null);
    }
    catch(ex) {
      notifications.error("Available Orders", 'Failed to load available orders.', ex)
    }
    finally{
      this.addOrdersLoading = false;
    }
  }

  removeOrder() {
    var selectedDetails = manifestModuleState.getSelectedManifestDetails;
    if(selectedDetails &&  selectedDetails.length > 0)
      manifestModuleState.removeManifestDetail(selectedDetails[0].orderId);
  }
  moveTop() {
    var selectedDetails = manifestModuleState.getSelectedManifestDetails;
    if(selectedDetails &&  selectedDetails.length > 0)
      manifestModuleState.moveManifestDetailTop(selectedDetails[0].orderId);
  }
  moveUp() {
    var selectedDetails = manifestModuleState.getSelectedManifestDetails;
    if(selectedDetails &&  selectedDetails.length > 0)
      manifestModuleState.moveManifestDetailUp(selectedDetails[0].orderId);
  }
  moveDown(detail) {
    var selectedDetails = manifestModuleState.getSelectedManifestDetails;
    if(selectedDetails &&  selectedDetails.length > 0)
      manifestModuleState.moveManifestDetailDown(selectedDetails[0].orderId);
  }
  moveBottom(detail) {
    var selectedDetails = manifestModuleState.getSelectedManifestDetails;
    if(selectedDetails &&  selectedDetails.length > 0)
      manifestModuleState.moveManifestDetailBottom(selectedDetails[0].orderId);
  }

  closeModals(){
    this.showAddOrderModal = false;
  }
}
